import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GtagService } from './containers/gtag/gtag.service';


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html'
})
export class AppComponent {
	constructor(
        private router: Router,
        private gtag: GtagService,
        @Inject(DOCUMENT) private doc: Document,
        @Inject(LOCALE_ID) private locale,
        @Inject(PLATFORM_ID) private platform,
    ) {
        this.doc.documentElement.lang = this.locale;
        if(isPlatformBrowser(this.platform)) {
            this.router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    this.gtag.firePageView(event.urlAfterRedirects);
                }
            });
        }
    }
}
